module.exports = __webpack_public_path__ + "frontend/images/green/carousel/static/2.png?68e8a79e9d4addd1cd4185a0933224fb";